import React, { useEffect, useState } from "react";
import { X } from "lucide-react";

const ERROR_EVENT = "application:error";

export const showError = (error) => {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : "Une erreur inattendue est survenue.";

  window.dispatchEvent(
    new CustomEvent(ERROR_EVENT, {
      detail: message || "Une erreur inattendue est survenue.",
    })
  );
};

function ErrorPopup() {
  const [message, setMessage] = useState("");

  useEffect(() => {
    const handleError = (event) => setMessage(event.detail);
    const handleKeyDown = (event) => {
      if (event.key === "Escape") setMessage("");
    };

    window.addEventListener(ERROR_EVENT, handleError);
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener(ERROR_EVENT, handleError);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  if (!message) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 p-4 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="error-popup-title"
      aria-describedby="error-popup-message"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) setMessage("");
      }}
    >
      <div className="relative w-[380px] max-w-full rounded-3xl border border-white/30 bg-white/90 p-8 text-center shadow-2xl backdrop-blur-xl animate-fadeIn">
        <button
          type="button"
          onClick={() => setMessage("")}
          className="absolute right-4 top-4 rounded-full p-2 text-gray-500 transition hover:bg-red-50 hover:text-red-600 focus:outline-none focus:ring-2 focus:ring-red-500"
          aria-label="Fermer le message d'erreur"
        >
          <X className="h-5 w-5" aria-hidden="true" />
        </button>

        <div className="mb-5 flex justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100 shadow-inner">
            <span className="text-3xl" aria-hidden="true">⛔</span>
          </div>
        </div>

        <h2
          id="error-popup-title"
          className="mb-2 text-xl font-semibold text-gray-900"
        >
          Une erreur est survenue
        </h2>

        <p id="error-popup-message" className="break-words text-gray-700">
          {message}
        </p>
      </div>
    </div>
  );
}

export default ErrorPopup;
